<template src="./Home.html"></template>

<script>
import { AppRetry } from "@/components/AppRetry";
import { AppHeader } from "./AppHeader";
import { AppSlider } from "./AppSlider";
import { AppFutureWeather } from "./AppFutureWeather";
import { AppFooter } from "./AppFooter";
import { AppSearchCity } from "./AppSearchCity";
import { common } from "@/utilities";
import { CalendarBasisEnum, LanguagesEnum, VersionTypesEnum } from "@/enums";
import { localization } from "@/constants";

export default {
  name: "Home",

  components: {
    AppRetry,
    AppHeader,
    AppSlider,
    AppFutureWeather,
    AppFooter,
    AppSearchCity,
  },

  mounted() {
    if (
      process.env.NODE_ENV === "development" &&
      !this.$route.query.xn &&
      !this.$route.query.xm
    ) {
      this.$store.commit("setQueryParams", {
        sub: {
          // xq: "مشهد",
          xq: { cityFaName: "تهران", cityEnName: "Tehran", cityCustomName: "" },
          xr: "#7FAEBC",
          xk: 36.29,
          xl: 59.62,

          // set for test gplay
          xz: CalendarBasisEnum.Solar,
          xo: LanguagesEnum.ar,
        },
        xb: VersionTypesEnum.PlayStore,

        xc: 17,
        xx: 0,
        // زبان در سمت سرور از این پراپتی دریافت میشود نه xo
        xn: "cSFr9BQTIx%2Bjk1bJ35Q6A%2Bb8hc2UHoObXjTUjNtM3zWMQxZU9T17DCYH5sQv9BJOe7aU2ytBsixkoT0kOCiAl8ZBkk3osE3NjXHZanohX%2BDsMkZ78E1evcqAdHM6sqTxkkFsye1a6K2Yimnnoa97OTS0OWOsGoDr50MMnQ8oS9OzxMKyX8XZfsP6ZJQFVCogNOyl667JzZPle1Gb5bq%2Bl2K3YEXtwRs75HwM94hVDJzn%2Fy1WHqrcDrDyGTUgilm%2Fk%2BrhMRjU8sVq4%2BnbBVDJoFvGU5gQ3ktTYxPR%2FD4wvoVqDvazsYG2GZqN%2Fti8U8mcZiOx41l%2BBckC36PqS4H43GHVDJl0t812z0GvWQ0g8A5Ew%2Bk3FMkbOsmyhgwGvDvmhU8G9L5DYt5j544lRrqxQw%3D%3D",
      });
    } else {
      if (!this.$route.query.xn || !this.$route.query.xm) {
        this.$store.commit("showSnackbar", {
          message: "عدم ارسال پارامترهای موردنیاز",
        });
        return;
      }
      this.setQueryParams();
    }

    if (
      this.$store.state.queryParams.xb === VersionTypesEnum.PlayStore &&
      this.$store.state.queryParams?.sub?.xo !== undefined
    ) {
      document.body.dir =
        localization[this.$store.state.queryParams.sub.xo].direction;
      // set localization by language
      this.$store.commit("setState", {
        localization: localization[this.$store.state.queryParams.sub.xo],
      });
    }

    // if (
    //   this.$store.state.queryParams.sub.xo &&
    //   this.$store.state.queryParams.sub.xo !== LanguagesEnum.fa
    // ) {
    //   return;
    // }

    this.$store.dispatch("getWeather");
  },

  methods: {
    // set query params (data from android) to store
    setQueryParams() {
      let queryData = null;
      try {
        queryData = {};
        if (this.$route.query.xm) {
          queryData = common.parseJwt(decodeURIComponent(this.$route.query.xm));
          queryData.sub = JSON.parse(queryData.sub);
          queryData.sub.xq = JSON.parse(queryData.sub.xq);

          // set default value
          if (queryData.sub.xz === null || queryData.sub.xz === undefined)
            queryData.sub.xz = CalendarBasisEnum.Solar;

          if (queryData.sub.xo === null || queryData.sub.xo === undefined)
            queryData.sub.xo = LanguagesEnum.fa;
        }
      } catch (error) {}

      const decodedQuery = {};
      Object.keys(this.$route.query).forEach((key) => {
        try {
          // convert string to number,bool,...
          decodedQuery[key] = JSON.parse(
            decodeURIComponent(this.$route.query[key])
          );
        } catch (error) {
          decodedQuery[key] = decodeURIComponent(this.$route.query[key]);
        }
      });

      // set default lat,lng
      if (!queryData.sub.xk) queryData.sub.xk = 35.7;
      if (!queryData.sub.xl) {
        queryData.sub.xl = 51.42;
        queryData.sub.xq = "تهران";
      }

      this.$store.commit("setQueryParams", {
        ...decodedQuery,
        ...queryData,
      });
    },

    handleRetry() {
      this.$store.dispatch("getWeather");
    },
  },
};
</script>
